export const SITE_URL = new URL(
  typeof window === "undefined"
    ? process.env.SITE_URL || "http://localhost:3000"
    : window.location.origin,
)

const graphqlServerApiBaseUrl =
  process.env.INTERNAL_GRAPHQL_API_BASE_URL || process.env.GRAPHQL_API_BASE_URL

export const GRAPHQL_CROSS_DOMAIN_GRAPHQL_API_BASE_URL =
  SITE_URL.origin === "https://opensea.io" ? "https://gql.opensea.io" : null

export const GRAPHQL_API_BASE_URL = new URL(
  graphqlServerApiBaseUrl ||
    GRAPHQL_CROSS_DOMAIN_GRAPHQL_API_BASE_URL ||
    `${SITE_URL.origin}/__api/`,
)

// Note - toString() adds a /, it looks weird but this is correct.
export const GRAPHQL_API_URL = new URL(
  `${GRAPHQL_API_BASE_URL.toString()}graphql`,
)

export const GRAPHQL_WS_BASE_URL =
  process.env.NEXT_PUBLIC_GRAPHQL_WS_BASE_URL ||
  "wss://os2-wss.prod.privatesea.io"
